import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { Redirect } from 'react-router'
import { push } from 'connected-react-router'

import { objectToArray, arrayToObject } from '../helper'
import OrderOptions from './OrderOptions'

import {
    RangeSelector
} from '../components'

export function OrderParticipantsComponent(props) {
    if (props.loading)
        return null

    if (props.orderType == "voucher" && (!props.training || !props.trainingType))
        return <Redirect to="/shop" />

    const participants = props.participants
    const training = props.training
    const trainingType = props.trainingType

    let price = 0.0
    if (props.voucherKind === 'amount') {
        price = props.voucherAmount
    } else {
        price = participants.length * training.price
    }


    return <article className={"shop-page page"}>
        <form onSubmit={() => props.next()}>
            <section className="section gray-section on-screen">
                <div className="section-content">
                    <div className="container">
                        <h1 className="text-center shop-title">Teilnehmer&shy;informationen</h1>
                        <div className="shop">
                            <div className="shop-content">
                                {participants.map((item, i) => (
                                    <div key={i}>
                                        <h2 className="form-headline">{i + 1}. Teilnehmer</h2>
                                        <label className="label-grid label-grid--small">
                                            <span className="label-text">Vorname*</span>
                                            <div className="label-control">
                                                <input className="input" type="text" value={item.firstName} name="firstName" required onChange={(e) => props.onParticipantChanged(i, e.target.name, e.target.value)} />
                                            </div>
                                        </label>
                                        <label className="label-grid label-grid--small">
                                            <span className="label-text">Nachname*</span>
                                            <div className="label-control">
                                                <input className="input" type="text" value={item.lastName} name="lastName" required onChange={(e) => props.onParticipantChanged(i, e.target.name, e.target.value)} />
                                            </div>
                                        </label>
                                    </div>
                                ))}

                                <p className="red">* Pflichtfelder</p>
                            </div>
                            <div className="shop-sidebar">
                                <OrderOptions {...props} prev={props.prev} nextType="submit" next={undefined} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </form>
    </article>
}

const OrderParticipants = connect(
    (state, props) => {
        const training = state.order.trainingId
            && arrayToObject(state.shop.trainings, 'id')[state.order.trainingId]
        return {
            orderType: state.orderType,
            voucherAmount: state.order.voucherAmount,
            loading: state.shop.loading,
            participants: state.order.participants,
            training: training,
            trainingType: training && state.shop.trainingTypes[training.trainingTypeId]
        }
    },
    (dispatch, props) => {
        return {
            prev: () => { dispatch(push('/bestellung/rechnungsinformationen')) },
            next: () => { dispatch(push('/bestellung/uebersicht')) },
            onParticipantChanged: (index, name, value) => {
                dispatch({ type: 'ORDER_PARTICIPANT_CHANGED', index, name, value })
            },
            onParticipantCountChanged: (participantCount) => {
                dispatch({ type: 'ORDER_PARTICIPANT_COUNT_CHANGED', participantCount })
            }
        }
    }
)(OrderParticipantsComponent)

export default OrderParticipants


// WEBPACK FOOTER //
// ./src/pages/OrderParticipants.jsx